<script>
import useSharedData from "@/use/SharedData.js";
import useTools from "@/use/Tools.js";
import {useSecurityStore} from "@/stores/Security.js"
import {onMounted, ref, watch} from "vue";
import useSharedMethod from "@/use/SharedMethod.js";
import {useTrainingSessionStore} from "@/stores/Training/TrainingSession.js";
import TrainingSessionFilter from "@/views/Training/TrainingSession/Components/TrainingSessionFilter.vue";
import {useTrainingPlanStore} from "@/stores/Training/TrainingPlan";
import axios from "axios";

export default {
    props: {
        type: String,
    },
    components: {TrainingSessionFilter},
    setup(props) {
        const {
            loading,
            total,
            itemsPerPage,
            filter,
        } = useSharedData();

        const {formatedDate, transformFilterValues} = useSharedMethod();

        const {$router, $i18n} = useTools();

        const trainingSessionStore = useTrainingSessionStore();
        const trainingPlanStore = useTrainingPlanStore();
        const securityStore = useSecurityStore();

        const candidateHeaders = [
            {
                text: "...",
                sortable: false,
                align: "left",
                value: "action",
                width: "0%",
            },
            {
                text: $i18n.t("common.code"),
                align: "start",
                sortable: true,
                value: "requestWorkerWorkerCode",
                width: "0%"
            },
            {
                text: $i18n.t("module.worker"),
                align: "start",
                sortable: true,
                value: "requestWorkerWorkerName",
                width: "0%"
            },
            {
                text: $i18n.t("common.here"),
                align: "start",
                sortable: true,
                value: "present",
                width: "0%"
            },
            {
                text: $i18n.t("common.done"),
                align: "start",
                sortable: true,
                value: "interviewClosed",
                width: "0%"
            },
            {
                text: $i18n.t("common.note"),
                align: "start",
                sortable: true,
                value: "interviewNote",
                width: "0%"
            },
            {
                text: $i18n.t("common.comment"),
                align: "start",
                sortable: true,
                value: "interviewDescription",
            },
        ]

        let headers = [
            {
                text: $i18n.t("common.code"),
                align: "start",
                sortable: true,
                value: "code",
                width: "0%"
            },
            {
                text: $i18n.t("training.theme"),
                align: "start",
                sortable: true,
                value: "catalogName",
                width: "0%"
            },
            /* {
                 text: $i18n.t("module.training_school"),
                 align: "start",
                 sortable: true,
                 value: "schoolName",
                 width: "0%"
             },
             {
                 text: $i18n.t("module.training_plan"),
                 align: "start",
                 sortable: true,
                 value: "planName",
                 width: "0%",
             },*/
            {
                text: $i18n.t("common.dates"),
                align: "start",
                sortable: true,
                value: "dates",
            },
            {
                text: $i18n.t("training.workers_number"),
                align: "start",
                sortable: true,
                value: "workerNumber",
                width: "0%",
            },


        ];

        let path;

        if (props.type === 'SESSION') {
            headers.unshift({
                text: "...",
                sortable: false,
                align: "left",
                value: "action",
                width: "0%",
            });

            headers.push({
                    // text: $i18n.t("training.concerned_evaluation_number"),
                    text: "Présent",
                    align: "start",
                    sortable: true,
                    value: "concernedTotal",
                    width: "0%",
                },
                /*{
                    text: $i18n.t("training.completed_evaluation_number"),
                    align: "start",
                    sortable: true,
                    value: "completedTotal",
                    width: "0%",
                },*/
                {
                    // text: $i18n.t("common.percent"),
                    text: "Etat",
                    align: "start",
                    sortable: false,
                    value: "totalPercent",
                });

            path = 'training_sessions';
        } else if (props.type === 'HOT') {
            headers.push({
                    // text: $i18n.t("training.concerned_evaluation_number"),
                    text: "Présent",
                    align: "start",
                    sortable: true,
                    value: "concernedHotEvaluationNumber",
                    width: "0%",
                },
                {
                    text: $i18n.t("common.done"),
                    align: "start",
                    sortable: true,
                    value: "completedHotEvaluationNumber",
                    width: "0%",
                },
                {
                    text: $i18n.t("common.percent"),
                    align: "start",
                    sortable: false,
                    value: "hotPercent",
                });
            path = 'training_hot_evaluations';
        } else if (props.type === 'COLD') {
            headers.push({
                    // text: $i18n.t("training.concerned_evaluation_number"),
                    text: "Présent",
                    align: "start",
                    sortable: true,
                    value: "concernedColdEvaluationNumber",
                    width: "0%",
                },
                {
                    text: $i18n.t("common.done"),
                    align: "start",
                    sortable: true,
                    value: "completedColdEvaluationNumber",
                    width: "0%",
                },
                {
                    text: $i18n.t("common.percent"),
                    align: "start",
                    sortable: false,
                    value: "coldPercent",
                });
            path = 'training_cold_evaluations';
        }

        const actions = [
            {
                title: $i18n.t("common.edit"),
                icon: 'mdi-pencil-box-multiple',
                color: 'orange',
                access: () => securityStore.authorities['UPDATE_TRAINING_SESSION'],
                disabled: (item) => item.launched || item.locked,
                func: (item) => {
                    $router.push({name: 'training_sessions.edit', params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("common.delete"),
                icon: 'mdi-trash-can',
                color: 'red',
                access: () => securityStore.authorities['DELETE_TRAINING_SESSION'],
                disabled: (item) => item.launched || item.locked,
                func: (item) => {
                    $router.push({name: 'training_sessions.delete', params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("common.launch"),
                icon: 'mdi-clock-start',
                color: 'cyan',
                access: () => securityStore.authorities['UPDATE_TRAINING_SESSION'],
                disabled: (item) => item.launched || item.locked,
                func: (item) => {
                    $router.push({name: 'training_sessions.launch', params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("training.pointing"),
                icon: 'mdi-timer-marker',
                color: 'purple',
                access: () => securityStore.authorities['UPDATE_TRAINING_SESSION'],
                disabled: (item) => !item.launched || item.locked,
                func: (item) => {
                    $router.push({name: 'training_sessions.pointing', params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("common.lock"),
                icon: 'mdi-lock',
                color: 'grey darken-2',
                access: () => securityStore.authorities['UPDATE_TRAINING_SESSION'],
                disabled: (item) => !item.launched || item.locked,
                func: (item) => {
                    $router.push({name: 'training_sessions.lock', params: {id: item.id}})
                },
            },
            {
                title: $i18n.t("module.edms"),
                icon: 'mdi-folder',
                color: 'amber',
                access: () => true,
                disabled: () => false,
                func: (item) => {
                    $router.push({name: `training_sessions.documents`, params: {id: item.id}})
                },
            },
        ];

        const searchParams = ref({
            sortBy: "postDateTime",
            descending: true,
            page: 1,
            itemsPerPage: itemsPerPage.value
        });

        function handleSearch(params) {
            loading.value = true;
            trainingSessionStore.setTrainingSessions([]);
            total.value = 0;

            filter.value.page = params.page - 1;
            filter.value.rowsPerPage = params.itemsPerPage;
            filter.value.sortBy = params.sortBy;
            filter.value.descending = params.descending;

            filter.value.locked = props.type === 'HOT' || props.type === 'COLD';

            axios.get('/trainingSessions', {params: transformFilterValues(filter.value)}).then((response) => {
                trainingSessionStore.setTrainingSessions(response.data.elements);
                total.value = response.data.total;
            }).finally(() => {
                loading.value = false;
            });
        }

        function findAll() {
            handleSearch(searchParams.value)
        }

        watch(() => filter.value, () => {
            searchParams.page = 1;
            findAll();
        }, {deep: true, immediate: true});

        watch(searchParams, (newParams) => {
            handleSearch(newParams);
        }, {deep: true});

        function clearFilter() {
            Object.keys(filter.value).forEach(key => {
                if (key === 'planId') {
                    filter.value[key] = trainingPlanStore.getMax();
                } else {
                    filter.value[key] = null;
                }
            });
        }

        function view(item) {
            $router.push({name: `${path}.view`, params: {id: item.id}});
        }

        const isOpen = ref(false);
        const isOpenLoading = ref(false);

        function existPlanOpen() {
            isOpenLoading.value = true;
            axios.get(`/trainingPlans/existPlanOpen`).then(response => {
                isOpen.value = response.data;
            }).finally(() => {
                isOpenLoading.value = false;
            });
        }

        function getTitle() {
            if (props.type === 'SESSION') {
                return $i18n.t('module.training_session');
            } else if (props.type === 'HOT') {
                return $i18n.t('module.training_hot_evaluations');
            } else if (props.type === 'COLD') {
                return $i18n.t('module.training_cold_evaluations');
            }
        }

        onMounted(() => existPlanOpen());

        function getHotPercent(item) {
            if (item.concernedHotEvaluationNumber)
                return item.completedHotEvaluationNumber * 100 / item.concernedHotEvaluationNumber;
            return 0;

        }

        function getColdPercent(item) {
            if (item.concernedColdEvaluationNumber)
                return item.completedColdEvaluationNumber * 100 / item.concernedColdEvaluationNumber;
            return 0;

        }

        function getTotalPercent(item) {
            if (item.concernedTotal)
                return item.completedTotal * 100 / item.concernedTotal;
            return 0;

        }

        return {
            trainingSessionStore,
            securityStore,
            headers,
            candidateHeaders,
            actions,
            searchParams,
            loading,
            total,
            itemsPerPage,
            filter,
            isOpen,
            isOpenLoading,
            getTitle,
            view,
            formatedDate,
            findAll,
            clearFilter,
            getHotPercent,
            getColdPercent,
            getTotalPercent,
        };
    },
};
</script>

<template>
    <div>
        <w-app
            :title="getTitle()"
            show-total
            :total="total"
            show-filter
            :filter="filter"
            @clearFilter="clearFilter"
        >
            <template v-slot:filter>
                <TrainingSessionFilter v-model="filter"/>
            </template>

            <template v-slot:rightToolbar>
                <w-btn-reload :loading="loading" @press="findAll"/>
                <w-btn-add
                    :show="type === 'SESSION' && securityStore.authorities['SAVE_TRAINING_SESSION']"
                    :disabled="!isOpen"
                    :loading="isOpenLoading"
                    @press="$router.push({ name: 'training_sessions.add' })"
                />
            </template>

            <template v-slot:content>
                <w-server-data-table
                    v-model="searchParams"
                    :headers="headers"
                    :actions="actions"
                    :items="trainingSessionStore.trainingSessions"
                    :total="total"
                    :loading="loading"
                    :show-expand="type !== 'SESSION'"
                    single-expand
                    root-path="training_sessions"
                    module="TRAINING_SESSION"
                    @rowDbClick="view"
                >
                    <template v-slot:[`item.code`]="{ item }">
                        <w-chip :text="item.code"/>
                    </template>
                    <template v-slot:[`item.catalogName`]="{ item }">
                        <w-inline-text bold :text="item.catalogName"/>
                    </template>
                    <template v-slot:[`item.schoolName`]="{ item }">
                        <w-inline-text :text="item.schoolName"/>
                    </template>
                    <template v-slot:[`item.planName`]="{ item }">
                        <w-inline-text :text="item.planName"/>
                    </template>
                    <template v-slot:[`item.dates`]="{ item }">
                        <w-chip-list :strings="item.dates.map(d => formatedDate(d))"/>
                    </template>
                    <template v-slot:[`item.workerNumber`]="{ item }">
                        <w-chip outlined :text="item.workerNumber"/>
                    </template>
                    <template v-slot:[`item.concernedHotEvaluationNumber`]="{ item }">
                        <w-chip outlined :text="item.concernedHotEvaluationNumber"/>
                    </template>
                    <template v-slot:[`item.completedHotEvaluationNumber`]="{ item }">
                        <w-chip color="teal" :text="item.completedHotEvaluationNumber"/>
                    </template>
                    <template v-slot:[`item.hotPercent`]="{ item }">
                        <v-progress-linear
                            :value="getHotPercent(item)"
                            color="teal lighten-2"
                            buffer-value="0"
                            stream
                            height="25"
                        >
                            <strong>{{ getHotPercent(item).toFixed(2) }}%</strong>
                        </v-progress-linear>
                    </template>
                    <template v-slot:[`item.concernedColdEvaluationNumber`]="{ item }">
                        <w-chip outlined :text="item.concernedColdEvaluationNumber"/>
                    </template>
                    <template v-slot:[`item.completedColdEvaluationNumber`]="{ item }">
                        <w-chip color="teal" :text="item.completedColdEvaluationNumber"/>
                    </template>
                    <template v-slot:[`item.coldPercent`]="{ item }">
                        <v-progress-linear
                            :value="getColdPercent(item)"
                            color="teal lighten-2"
                            buffer-value="0"
                            stream
                            height="25"
                        >
                            <strong>{{ getColdPercent(item).toFixed(2) }}%</strong>
                        </v-progress-linear>
                    </template>
                    <template v-slot:[`item.concernedTotal`]="{ item }">
                        <w-chip outlined :text="item.concernedTotal"/>
                    </template>
                    <template v-slot:[`item.completedTotal`]="{ item }">
                        <w-chip color="teal" :text="item.completedTotal"/>
                    </template>
                    <template v-slot:[`item.totalPercent`]="{ item }">
                        <w-chip :text="item.pointingValid ? $t('common.locked') : $t('common.in_progress')"/>
                        <!--<v-progress-linear
                            :value="getTotalPercent(item)"
                            color="teal lighten-2"
                            buffer-value="0"
                            stream
                            height="25"
                        >
                            <strong>{{ getTotalPercent(item).toFixed(2) }}%</strong>
                        </v-progress-linear>-->
                    </template>
                    <template v-slot:expanded-item="{ item, headers }">
                        <td :colspan="1" style="background-color: #EEEEEE"></td>
                        <td :colspan="headers.length - 1" style="background-color: #EEEEEE">
                            <v-container fluid>
                                <w-data-table
                                    v-if="type === 'HOT'"
                                    :headers="candidateHeaders"
                                    :items="item.candidates"
                                    sort-by="requestWorkerWorkerName"
                                    disable-pagination
                                >
                                    <template v-slot:[`item.action`]="{ item }">
                                        <w-btn-icon
                                            :disabled="!item.present"
                                            icon="mdi-clipboard-text-clock"
                                            color="blue darken-2"
                                            @press="$router.push({name: 'training_hot_evaluations.interview.view', params: {id: item.id}})"
                                        />
                                    </template>
                                    <template v-slot:[`item.requestWorkerWorkerCode`]="{ item }">
                                        <w-chip :text="item.requestWorkerWorkerCode"/>
                                    </template>
                                    <template v-slot:[`item.requestWorkerWorkerName`]="{ item }">
                                        <w-inline-text bold :text="item.requestWorkerWorkerName"/>
                                    </template>
                                    <template v-slot:[`item.present`]="{ item }">
                                        <v-simple-checkbox
                                            :value="true"
                                            :color="item.present ? 'teal' : 'red'"
                                        />
                                    </template>
                                    <template v-slot:[`item.interviewClosed`]="{ item }">
                                        <v-simple-checkbox
                                            :disabled="!item.present"
                                            :value="item.interviewClosed"
                                            color="blue darken-2"
                                        />
                                    </template>
                                    <template v-slot:[`item.interviewNote`]="{ item }">
                                        <w-chip
                                            :disabled="!item.present"
                                            color="teal"
                                            :text="item.present ? item.interviewNote : '0'"
                                        />
                                    </template>
                                    <template v-slot:[`item.interviewDescription`]="{ item }">
                                         <span v-if="item.present">
                                            {{ item.interviewDescription }}
                                        </span>
                                    </template>
                                </w-data-table>
                            </v-container>
                        </td>
                    </template>
                </w-server-data-table>
            </template>

        </w-app>

        <router-view/>
    </div>
</template>